import * as OpenSansRegular from '@app/src/assets/fonts/open-sans/open-sans-regular.woff2';
import * as AristotelicaRegular from '@app/src/assets/fonts/aristotelica/aristotelica-regular.woff2';
import * as AristotelicaExtraLight from '@app/src/assets/fonts/aristotelica/aristotelica-extralight.woff2';
import * as RobotoRegular from '@app/src/assets/fonts/roboto/roboto-regular.woff2';
import * as RobotoBold from '@app/src/assets/fonts/roboto/roboto-bold.woff2';
import * as MontserratBold from '@app/src/assets/fonts/montserrat/montserrat-bold.woff2';
import * as MontserratRegular from '@app/src/assets/fonts/montserrat/montserrat-regular.woff2';
import * as LatoRegular from '@app/src/assets/fonts/lato/lato-regular.woff2';

export const fonts = `
  @font-face{
    font-family: open-sans;
    src: url(${OpenSansRegular}) format("woff2");
    font-style:normal;
    font-weight:400;
    font-display:swap;
  }
  @font-face{
    font-family: aristotelica;
    src: url(${AristotelicaRegular}) format("woff2");
    font-style:normal;
    font-weight:400;
    font-display:swap;
  }
  @font-face{
    font-family: aristotelica-extralight;
    src: url(${AristotelicaExtraLight}) format("woff2");
    font-style:normal;
    font-weight:400;
    font-display:swap;
  }
  @font-face{
    font-family: roboto;
    src: url(${RobotoRegular}) format("woff2");
    font-style:normal;
    font-weight:400;
    font-display:swap;
  }
  @font-face{
    font-family: roboto-bold;
    src: url(${RobotoBold}) format("woff2");
    font-style:normal;
    font-weight:400;
    font-display:swap;
  }
  @font-face{
    font-family: montserrat;
    src: url(${MontserratRegular}) format("woff2");
    font-style:normal;
    font-weight:400;
    font-display:swap;
  }
  @font-face{
    font-family: montserrat-bold;
    src: url(${MontserratBold}) format("woff2");
    font-style:normal;
    font-weight:400;
    font-display:swap;
  }
  @font-face{
    font-family: lato;
    src: url(${LatoRegular}) format("woff2");
    font-style:normal;
    font-weight:400;
    font-display:swap;
  }
`;
